import { categories } from "@/mocks/chigua";

export type Cat = (typeof categories)[number];

export function catOf(id: string): Cat {
  return categories.find((c) => c.id === id) ?? categories[0];
}

const tones = [
  "bg-primary-100 text-primary-900",
  "bg-accent-100 text-accent-900",
  "bg-secondary-100 text-secondary-900",
  "bg-background-200 text-foreground-800",
  "bg-primary-50 text-primary-700",
  "bg-accent-50 text-accent-700",
];

export function catTone(id: string): string {
  const idx = categories.findIndex((c) => c.id === id);
  return tones[((idx % tones.length) + tones.length) % tones.length];
}